import { createFileRoute, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach/library/")({
  component: RouteComponent,
  loader() {
    return loaderHandler(() => {
      throw redirect({
        to: "/library/programs",
      });
    });
  },
});

function RouteComponent() {
  return null;
}
